import { render, staticRenderFns } from "./InactiveCustomers.vue?vue&type=template&id=215318a4&scoped=true&"
import script from "./InactiveCustomers.vue?vue&type=script&lang=js&"
export * from "./InactiveCustomers.vue?vue&type=script&lang=js&"
import style0 from "./InactiveCustomers.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InactiveCustomers.vue?vue&type=style&index=1&id=215318a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215318a4",
  null
  
)

export default component.exports